import { AppHelper } from "../appHelper"
import { AnnualVacationEditApp, AnnualVacationEditAppProps } from "../vacation/annualVacationEdit"
import { Button } from "../core/components/button";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService, HTTPRequestType, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { EntityResource, ResourceAppPropsContext } from "./resource";
import { AppBaseProps, Entity, Metadata } from "../core/components/commonApp";
import { CommandManagerAPI } from "../commonInterfaces";
import React from "react";
interface VacationViewModel extends Entity {
    VacationRessProperties: Array<VacationRessProperties>;
}

interface VacationRessProperties extends Entity {
    RessNr: string;
    VorName: string;
    Name: string;
    Jahresurlaub: number;
    Jahr: number;
}

interface AnnualVacationViewAppProps extends AppBaseProps {
    data: VacationViewModel;
    metadataVacationEdit: Metadata;
}

interface VacationViewModel extends Entity {
    VacationRessProperties: Array<VacationRessProperties>;
}

interface VacationRessProperties extends Entity {
    RessNr: string;
    VorName: string;
    Name: string;
    Jahresurlaub: number;
    Jahr: number;
}

interface AnnualVacationViewAppProps extends AppBaseProps {
    data: VacationViewModel;
    metadataVacationEdit: Metadata;
}

interface VacationListFilter {
    RessNr: string[];
    Ogrnr: number[];
    GrNr: number[];
    Jahr: number;
}

export default class Vacation extends React.Component<VacationProps, any> {
    private _metaDataVacationEdit;
    private _list;
    private _listPlanung = null;
    private _listRessurlaub = null;
    common = new AppHelper();
    filter: VacationListFilter;
    vacationListGridOptions = [];
    ressurlaubGridOptions = [];
    year = new Date().getFullYear();
    grid = false;
    gridRessUrlaub = false;
    enableGrid = false;
    private _firstYear = 0;

    constructor(props) {
        super(props);
        this.addOne = this.addOne.bind(this);
        this.substractOne = this.substractOne.bind(this);
        this.getGrid();
        this.getRessUrlaub();
        this._getFirstEntry();
        this.renderButtonInhalt();
    }

    private _getFirstEntry = async () => {
        let result = await HTTPService.get<JsonResultClass<number>>("Vacation/GetFirstEntry?RessNr=" + this.props.entity.Ressnr);
        this._firstYear = result.Data;
        this.setState({})
    }

    private async renderButtonInhalt() {
        let metadataVacationEdit;

        let result = await HTTPService.chainBatch
            .add<JsonResultClass>("Vacation/GetVacation?ressNr=" + encodeURIComponent(this.props.entity.Ressnr) + "&year=" + encodeURIComponent(this.year))
            .add<Metadata>(Helper.getMetaData("vacation"))
            .add<Metadata>(Helper.getMetaData("vacationEdit"))
            .promise();
        this._list = result[0];
        metadataVacationEdit = result[2];
        if (this._list.Code > 0) {
            NotificationHelper.showErrorMessage(this._list.Message);
        } else {
            this._metaDataVacationEdit = {
                metadataVacationEdit: metadataVacationEdit,
                isWindow: true
            };
        }
    }

    private async getGrid() {
        if (!this.grid) {
            let result = await HTTPService.post<PlanungUrlaubsZeitraeume>("Vacation/GetPlanungUrlaubsZeitraeume", { Jahr: this.year, RessNr: this.props.entity.Ressnr });
            this._listPlanung = result;

            if (this._listPlanung.Data.PlanungUrlaubsZeitraeume.length == 0) {
                this._listPlanung = null;
            }
            this.grid = true;
            if (this._listPlanung != null && this._listRessurlaub != null) {
                this.enableGrid = true;
            } else {
                this.enableGrid = false;
            }

            this.setState({})
        }
    }

    private async getRessUrlaub() {
        if (!this.gridRessUrlaub) {
            let result = await HTTPService.get<JsonResultClass<RessUrlaubsZeitraum>>("Vacation/GetRessUrlaubZeitraum", { Jahr: this.year, RessNr: this.props.entity.Ressnr });
            this._listRessurlaub = result.Data;
            if (result.Data.RessurlaubZeitstich.length == 0) {
                this._listRessurlaub = null;
            }
            this.gridRessUrlaub = true;
            this.enableGrid = this._listPlanung != null && this._listRessurlaub != null;
            this.setState({})
        }
    }

    private addOne() {
        if (new Date().getFullYear() + 1 != this.year) {
            this.year = this.year + 1;
            this.grid = false;
            this.gridRessUrlaub = false;
            this.getGrid();
            this.getRessUrlaub();
            this.renderButtonInhalt();
            this.setState({})
        }
    }

    private substractOne() {
        this.year = this.year - 1;
        this.grid = false;
        this.gridRessUrlaub = false;
        this.getGrid();
        this.getRessUrlaub();
        this.renderButtonInhalt();
        this.setState({})
    }

    render() {
        if (this.props.entity.IsNew) {
            return null;
        } else {
            return (
                <>
                    {this.renderButton()}
                    {this.renderGrid()}
                </>
            );
        }
    }

    private handleVacationEditClick = () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Config.translations.editLabel);
        let entity: VacationRessProperties = this._list.Data;
        if (!Helper.hasValue(entity)) {
            entity = {
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                Jahr: new Date().getFullYear(),
                Jahresurlaub: 0,
                Name: this.props.entity.Name,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                RessNr: this.props.entity.Ressnr,
                VorName: this.props.entity.Vorname,
                IndividualFields: null
            };
        }
        sheet.show(() => {
            const props: AnnualVacationEditAppProps = {
                context: this.props.context,
                dataSources: this.props.entity,
                title: "",
                metadata: this._metaDataVacationEdit.metadataVacationEdit,
                entity: entity,
                isWindow: true
            };
            sheet.mountContent(AnnualVacationEditApp, props);
            sheet.bind(SheetEventType.Close, () => {
                this.gridRessUrlaub = false;
                this.getRessUrlaub();
            });
        });
    }


    renderButton() {
        return (
            <>
                <Button readOnly={!this.props.entity.RecordRight.CanWrite} handleClick={this.handleVacationEditClick} iconName={"edit"} />
            </>);
    }

    renderGrid() {
        const arrorRightStyle: React.CSSProperties = {
            cursor: 'pointer',
            marginLeft: '10px',
            visibility: (new Date().getFullYear() + 1 != this.year) ? "visible" : "hidden"
        };

        const arrorLeftStyle: React.CSSProperties = {
            cursor: 'pointer',
            marginRight: '10px',
            visibility: (this.year > this._firstYear) ? "visible" : "hidden"

        };


        return (
            <>
                <div style={{ color: '#767676', fontWeight: 'bold', display: 'flex', justifyContent: 'center', fontSize: '16px', marginBottom: '5px' }}>
                    <div id='pfeilLinks' onClick={this.substractOne} style={arrorLeftStyle}>
                        {'<'}
                    </div>
                    <p >{this.year}</p>
                    <div id='pfeilRechts' onClick={this.addOne} style={arrorRightStyle}>
                        {'>'}
                    </div>
                </div>
                <div>
                    <p style={{ color: '#767676', fontWeight: 'bold', fontSize: '16px', marginTop: '15px', marginBottom: '5px' }}>
                        {this.props.context.translations["Ressource.Einzelaufschlüsselung"]}
                    </p>
                    <Grid data={this._listPlanung === null ? [] : this._listPlanung.Data.PlanungUrlaubsZeitraeume} options={this.props.context.vacationListGridOptions} id="vacationList" />
                    <p style={{ color: '#767676', fontWeight: 'bold', fontSize: '16px', marginTop: '15px', marginBottom: '5px' }}>
                        {this.props.context.translations["WebSMS.Vacation.GesamtübersichtDesJahres"]}
                    </p>
                    <Grid data={this._listRessurlaub === null ? [] : this._listRessurlaub.RessurlaubZeitstich} options={this.props.context.ressurlaubGridOptions} id="spareVacation" />
                </div>
            </>
        );
    }
}

export interface VacationProps {
    entity: EntityResource;
    context: ResourceAppPropsContext;
    commandManager?: CommandManagerAPI;
    translation: {};
    handleEval?(expression: string);
    onChange(field: { model: string }, value: any, dataItem?: any);
}
//interface PlanungUrlaubsZeitraeumeArray {
//    Data: Data;
//    ready: boolean;
//    Code;
//    Message;
//}

interface Data {
    PlanungUrlaubsZeitraeume: Array<PlanungUrlaubsZeitraeume>
}

interface PlanungUrlaubsZeitraeume {
    Startist: Date;
    Endeist: Date;
    Tage: number;
    Wochenend: number;
    Geplant: number;
    Halbertag: number;
}


interface RessUrlaubsZeitraum {
    RessurlaubZeitstich: Array<RessurlaubZeitstich>;
    ready: boolean;
    Code;
    Message;
}

interface RessurlaubZeitstich {
    SonderUrlaub: number;
    Jahr: number;
    JahresUrlaub: number;
    RestVorJahr: number;
    RessNr: String;
}